import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from 'buyside/components/presentation/Accordion/accordionComponents';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';
import PdfViewer from 'buyside/components/presentation/IdeaShowPage/Thesis/pdfViewer';

import styles from 'buyside/components/presentation/WhitePaper/ShowPage/styles.scss';

import { Maybe } from 'interfaces/graphql-typings';

interface ThesisProps {
  thesis: string;
  pdfThesisUrl: Maybe<string>;
  positionDisclaimerFund: boolean;
  positionDisclaimerIndividual: boolean;
}

const Thesis: React.FC<ThesisProps> = ({
  thesis,
  pdfThesisUrl,
  positionDisclaimerFund,
  positionDisclaimerIndividual
}): React.ReactElement => {
  let disclaimerText;
  if (positionDisclaimerIndividual && positionDisclaimerFund) {
    disclaimerText =
      "The author of this macro/thematic report and the author's fund had a position in this security at the time of posting and may trade in and out of this position without informing the SumZero community.";
  } else if (positionDisclaimerIndividual) {
    disclaimerText =
      'The author of this macro/thematic report had a position in this security at the time of posting and may trade in and out of this position without informing the SumZero community.';
  } else if (positionDisclaimerFund) {
    disclaimerText =
      "The author's fund had a position in this security at the time of posting and may trade in and out of this position without informing the SumZero community.";
  }

  return (
    <div id="whitePaperThesis" className={styles.thesisContainer}>
      <Accordion basic>
        <AccordionTitle
          expandable
          isLocked={false}
          expandIcon={faPlus}
          collapseIcon={faMinus}
          dataTag="thesis"
        >
          Thesis
        </AccordionTitle>
        <AccordionContent>
          <div>
            {disclaimerText && (
              <div className={styles.disclaimer}>
                <strong>Disclaimer:</strong> {disclaimerText}
              </div>
            )}
            {pdfThesisUrl ? (
              <PdfViewer fileUrl={pdfThesisUrl} />
            ) : (
              <ParsedHtml html={thesis}>
                {({ content, tinyMceStyles }): React.ReactNode => (
                  <div className={tinyMceStyles}>{content}</div>
                )}
              </ParsedHtml>
            )}
          </div>
        </AccordionContent>
      </Accordion>
    </div>
  );
};

export default Thesis;
